export const nextTermPlanningConstant = {
	NYC: {
		headers: ['StudentID', 'LastName', 'FirstName', 'GradeLevel', 'OfficialClass', 'Course', 'Section', 'Action'],
		columnKeys: ['studentId', 'firstName', 'lastName', 'grade', 'officialClass']
	},
	Lansing: {
		headers: ['StudentID', 'LastName', 'FirstName', 'GradeLevel', 'Course', 'Section', 'Action'],
		columnKeys: ['studentId', 'firstName', 'lastName', 'grade']
	}
}